import config from '../../../../../config'

export const RATE_DEBOUNCE_TIME = 500
export const MEDIA_MAIL_METHOD = 'USPSMedia'
export const NO_PACKER_VALUE = -1
export const E_UNEXPECTED_BUY_FAILURE = 'Unexpect error: Failed to purchase rate. Please refresh and try again.'
export const DEFAULT_COUNTRY = 'US'
export const DEFAULT_EEL_PFC = 'NOEEI 30.37(a)'
export const INSURANCE_RATE_OF_DECLARED_VALUE = 0.008
export const MINIMUM_INSURANCE_COST = 0.8
export const FREE_INSURANCE_AMOUNT = 100
const provider = config.SHIPSURANCE() ? 'Shipsurance' : 'EasyPost'
export const INSURANCE_PROVIDER: 'carrier' | 'EasyPost' | 'Shipsurance' = config.CARRIER_INSURANCE()
  ? 'carrier'
  : provider
export const MAX_DECLARED_VALUE = 15000
